import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'clp-image-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    imports: [
        TranslateModule
    ]
})

export class ImageUploadComponent{
    @Input() imageDataUrl?: string;
    @Output() imageFile = new EventEmitter<File>();
    @Output() deleteImageFile = new EventEmitter();
    
    @ViewChild('fileInput', { static: true }) fileInput!: ElementRef<HTMLInputElement>;

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (event && event.dataTransfer)
            event.dataTransfer.effectAllowed = 'copy';
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();

        const files = event?.dataTransfer?.files;
        if (files && files.length > 0) {
        this.handleFile(files[0]);
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const files = input.files;
        if (files && files.length > 0) {
        this.handleFile(files[0]);
        }
    }

    delete() {
        this.imageDataUrl = undefined; 
        this.deleteImageFile.emit(true);
    }

    handleFile(file: File): void {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {        
            this.imageDataUrl = reader.result as string;
            this.imageFile.emit(file);
            this.deleteImageFile.emit();
        };
    }
    
}
